import { showToast } from "@core/component/toast/toast.js";

export default (
    titleKey,
    messageKey,
    confirmLabelKey,
    cancelLabelKey
) => ({
    init() {
        this._confirmed = false;

        this._handler = async (event) => {
            if (this._confirmed) return;

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const title = getMessage(titleKey || 'kibe.form.confirm.title');
            const message = getMessage(messageKey || 'kibe.form.confirm.message');
            const confirmLabel = getMessage(confirmLabelKey || 'kibe.form.btn.confirm');
            const cancelLabel = getMessage(cancelLabelKey || 'kibe.form.btn.cancel');

            const result = await showToast({
                title,
                message,
                type: 'danger',
                actions: [
                    {
                        id: 'confirm',
                        label: confirmLabel,
                        class: 'btn btn-danger btn-sm'
                    },
                    {
                        id: 'cancel',
                        label: cancelLabel,
                        class: 'btn btn-secondary btn-sm'
                    }
                ],
                modal: true
            });

            if (result === 'confirm') {
                this._confirmed = true;

                if (this.$el.tagName === 'FORM') {
                    this.$el.dispatchEvent(new SubmitEvent('submit', { bubbles: true, cancelable: true }));
                } else {
                    this.$el.click(); // relance le click pour htmx
                }
            }
        };

        if (this.$el.tagName === 'FORM') {
            this.$el.addEventListener('submit', this._handler, { capture: true });
        } else {
            this.$el.addEventListener('click', this._handler, { capture: true });
        }
    },

    destroy() {
        this.$el.removeEventListener('submit', this._handler, { capture: true });
        this.$el.removeEventListener('click', this._handler, { capture: true });
        this._handler = null;
    }
});